import { metaAccount } from '@/router/meta-config'
// TODO
const permissionKey = 'PLACE'

export default [
  // places
  {
    path: '/ordersEvent',
    name: 'page-orders-event',
    component: () => import('@/pages/ordersEvent'),
    meta: {
      ...metaAccount,
      permissionKey
    }
  }
]
